<template>
     <div class="page-content">

           <v-row>
    <v-col cols="12" sm="12" >
        <div class="content-wrap">
            <h1 class="page-title text-center" style="margin-top: 70px;">Welcome to our beta testing</h1>
            <div class="text-center">
                GameEnable constantly releasing new development for it's beta testing group.<br>
                To join the Beta testing please click on the button below.<br>
            </div>
            <br>
            <v-img
                    alt="GameEnable"
                    class="shrink mr-2"
                    contain
                    src="../assets/potion.svg"
                    width="130"
                    style="width: 130px; position: relative; margin: 10px auto 40px auto!important;"
            />
            <div class="text-center">
                <v-btn class="action-button text-center "  id="purchase-button" style="width:250px!important;position:relative;margin:20px auto 60px auto;"
                       @click="submit" v-text="submited? 'Done! redirecting...'  : 'Join Beta'"> </v-btn>
            </div>

        </div>


        <v-card
              style="margin-top:20px;"
                class="mx-auto"
        >



    <v-card-text style="padding-right:100px;">
      <span v-html="$t('faq.socialMedia')"></span>
    </v-card-text>

    <v-card-actions style="    position: absolute;right: 0;bottom: 0;">
      <v-spacer></v-spacer>
      <v-btn href="mailto: gameenable.com@gmail.com" icon>
        <v-icon>mdi-email</v-icon>
      </v-btn>
      <v-btn icon target="_blank" href="https://twitter.com/enablegame">
        <v-icon>mdi-twitter</v-icon>
      </v-btn>
      <v-btn icon target="_blank" href="https://discord.gg/V6fv3Nx">
        <v-icon>mdi-discord</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>

    </v-col>



  </v-row>

        </div>
</template>

<style>

  .page-title {
    font-weight:300;font-size:27px;margin-bottom:15px;

  }

  .mobile .page-title {
    text-align: center;
  }

    .page-content {

    }

    .content-wrap{

        min-height:500px;
        padding: 0 10px;
    }

</style>

<script>

  import Page from '../mixins/page'

  export default {
    name: 'FAQ',
    mixins: [Page],
      data: ()=> ({
          submited: false
      }),
      methods: {
          submit() {
              this.submited = true;
              localStorage.allowdns = 1;
              setTimeout(()=> this.$router.push({name: 'Account', params: { lang: this.$i18n.locale }}), 3000);
          }
      }
  };
</script>
